<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Islem"
    }
</script>

<style scoped>

</style>